import { Media } from '@crimsontide/core/client/interfaces';
import DotNetObject = DotNet.DotNetObject;

export const MediaService = (() => {
  let dotNetObj: DotNetObject;
  let cachedMedias: Media[];

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getMedia = async (useCache: boolean = true): Promise<Media[]> => {
    if (useCache && cachedMedias != null)
      return cachedMedias;

    if (dotNetObj) {
      cachedMedias = await dotNetObj.invokeMethodAsync<Media[]>('GetAsync');
      return cachedMedias;
    } else {
      throw 'Media DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getMedia,
  };
})();
